__turbopack_context__.v({
  "contentContainer": "whyChooseUs-module-scss-module__kWt_KG__contentContainer",
  "headerContainer": "whyChooseUs-module-scss-module__kWt_KG__headerContainer",
  "row": "whyChooseUs-module-scss-module__kWt_KG__row",
  "rowReverse": "whyChooseUs-module-scss-module__kWt_KG__rowReverse",
  "textContainer": "whyChooseUs-module-scss-module__kWt_KG__textContainer",
  "textContent": "whyChooseUs-module-scss-module__kWt_KG__textContent",
  "whyChooseUs": "whyChooseUs-module-scss-module__kWt_KG__whyChooseUs",
});
